import { Location, Router } from '@reach/router';
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

interface IAnimatedRouter {
  children: JSX.Element[];
  className?: string;
}

{
  /* the only difference between a router animation and
              any other animation is that you have to pass the
              location to the router so the old screen renders
              the "old location" */
}
const AnimatedRouter = ({ children, className }: IAnimatedRouter) => (
  <Location>
    {({ location }) => (
      <TransitionGroup className={`transition-group ${className || ''}`}>
        <CSSTransition key={location.pathname.split('/')[1]} classNames="fade" timeout={500}>
          <Router primary={false} location={location} className="router">
            {children}
          </Router>
        </CSSTransition>
      </TransitionGroup>
    )}
  </Location>
);

export { AnimatedRouter };
